module.exports = __webpack_public_path__ + "img/poligr.c48477f8.jpg";